import React from 'react';
import clsx from 'clsx';

import './index.sp.scss';
import SpBasicTemplate from 'components/templates/SpBasicTemplate';
import SpInputLine from 'components/molecules/SpInputLine';
import SpInputTitleMessage from 'components/molecules/SpInputTitleMessage';
import SpMarketPrice from 'components/molecules/SpMarketPrice';
import TypeRadio from 'components/atoms/Input/TypeRadio';
import PulldownInput from 'components/atoms/Input/PulldownInput';
import NormalCheckBoxInput from 'components/atoms/Input/NormalCheckBoxInput';
import CalendarInput from 'components/atoms/Input/CalendarInput';
import CheckBox from 'components/atoms/Input/CheckBoxInput';
import TextBox from 'components/atoms/Input/TextBox';
import TextAreaBox from 'components/atoms/Input/TextAreaBox';
import PcErrorArea from 'components/molecules/PcErrorArea';

const PresentSP = ({ 
  // 就業期間from
  tommorow,
  fromDate,
  calFromPlaceholder,
  handleChangeFromDate,
  // 就業期間to
  minToDate,
  toDate,
  handleChangeToDate,
  pendingToDateFlag,
  handleChangeToDateFlag,
  calToPlaceholder,
  // 勤務形態
  workStyle,
  handleChangeWorkStyle,
  workStyleList,
  // 就業日数
  minBusinessDayList,
  minBusinessDay,
  handleChangeMinBusinessDay,
  maxBusinessDayList,
  maxBusinessDay,
  handleChangeMaxBusinessDay,
  // 就業曜日
  dayOfTheWeekList,
  dayOfTheWeek,
  handleChangeDayOfTheWeek,
  // シフト区分
  workStyleKbn,
  handleChangeWorkStyleKbn,
  workStyleKbnList,
  // 就業時間from 固定勤務
  startHourList,
  fixedStartHour,
  handleChangeFixedStartHour,
  startMinList,
  fixedStartMin,
  handleChangeFixedStartMin,
  // 就業時間to 固定勤務
  endHourList,
  fixedEndHour,
  handleChangeFixedEndHour,
  endMinList,
  fixedEndMin,
  handleChangeFixedEndMin,
  // 休憩時間 固定勤務
  restTimeList,
  fixedRestTime,
  handleChangeFixedRestTime,
  // 就業時間 早番~夜勤
  ShiftTypeList,
  // 車通勤
  canCommuteByCar,
  handleChangeCanCommuteByCar,
  canCommuteByCarList,
  // 時給、サジェスト
  hourSalary,
  handleChangeHourSalary,
  suggestHourSalaryDisp,
  // その他条件
  freeComment,
  handleChangeFreeComment,  
  // 更新、エラーチェック
  onClickMainButton,
  valid,
  errorDispMap,
  isApiError,
  warn,
  lpMode,
}) => (
  <div className="Cond">
    <SpBasicTemplate 
      path={window.location.pathname}
      onClickMainButton={onClickMainButton}
      valid={valid}
      isApiError={isApiError}
      lpMode={lpMode}
    >
      {/* 就業期間 */}
      <SpInputTitleMessage 
        title="期間"
        message="※31日以上を選択してください"
      >
        <CalendarInput 
          minDate={tommorow}
          selected={fromDate}
          handleChange={handleChangeFromDate}
          placeholder={calFromPlaceholder}
          left
        />
  
        <div className="P-C-from-to">~</div>
        <CalendarInput 
          minDate={minToDate}
          selected={toDate}
          handleChange={handleChangeToDate}
          radioSelected={pendingToDateFlag}
          radioChange={handleChangeToDateFlag}
          placeholder={calToPlaceholder}
          right
        />

        <PcErrorArea message={errorDispMap.syuugyouKikan} />
      </SpInputTitleMessage>

      {/* 勤務形態 */}
      <div className="sp-workStyle">
        <SpInputLine title="勤務形態">
          {workStyleList.map((label)=>{
            return(
              <TypeRadio
                key={label.label}
                value={label.value}
                onChange={handleChangeWorkStyle}
                checked={workStyle === label.value}
                label={label.label}
              />
            );
          })}
        </SpInputLine>
      </div>
      {/* 就業日数 */}
      <SpInputLine title="就業日数/週">
        <PulldownInput
          items={minBusinessDayList}
          selectedValue={minBusinessDay}
          onChange={handleChangeMinBusinessDay}
        />
        <div className="P-C-label">日</div>
        <div className="P-C-wave">~</div>
        <PulldownInput
          items={maxBusinessDayList}
          selectedValue={maxBusinessDay}
          onChange={handleChangeMaxBusinessDay}
        />
        <div className="P-C-label">日</div>
        <PcErrorArea message={errorDispMap.businessDay} />
      </SpInputLine>

      {/* 就業曜日 */}
      <span className="week">
        <SpInputLine title="就業曜日">
          {dayOfTheWeekList.map((label) => {
            return (
              <CheckBox
                checked={dayOfTheWeek.includes(label.value)}
                key={label.value}
                label={label.label}
                onChange={handleChangeDayOfTheWeek}
                value={label.value}
              />
            );
          })}
          <PcErrorArea message={errorDispMap.dayOfTheWeek} />
        </SpInputLine>
      </span>

      {/* 勤務形態によってだし分け */}
      <div className={clsx(
        'selectedShift',
        { fixed: workStyle === '01' },
        { shift: workStyle === '02' },
        { other: workStyle !== '01' && workStyle !== '02' },
      )}
      >
        {/* シフト区分 シフト勤務が選択された場合に表示 */}
        <div className="sp-shift">
          <SpInputLine title="シフト区分">
            {workStyleKbnList.map((label) => {
              return (
                <NormalCheckBoxInput
                  id={label.label}
                  key={label.label}
                  checked={workStyleKbn.includes(label.value)}
                  label={label.label}
                  onChange={handleChangeWorkStyleKbn}
                  value={label.value}
                  color="0"
                />
              );
            })}
            <PcErrorArea message={errorDispMap.workStyleKbn} />
          </SpInputLine>
        </div>
        
        {/* 就業時間 固定勤務が選択された場合に表示 */}
        <div className="sp-fixed">
          {/* 就業時間 */}
          <SpInputLine title="就業時間">
            {/* 開始（時：分） */}
            <PulldownInput
              items={startHourList}
              selectedValue={fixedStartHour}
              onChange={handleChangeFixedStartHour}
            />
            <div className="P-C-colon">:</div>
            <PulldownInput
              items={startMinList}
              selectedValue={fixedStartMin}
              onChange={handleChangeFixedStartMin}
            />

            <div className="P-C-wave">~</div>
      
            {/* 終了（時：分） */}
            <PulldownInput
              items={endHourList}
              selectedValue={fixedEndHour}
              onChange={handleChangeFixedEndHour}
            />
            <div className="P-C-colon">:</div>
            <PulldownInput
              items={endMinList}
              selectedValue={fixedEndMin}
              onChange={handleChangeFixedEndMin}
            />
            <PcErrorArea message={errorDispMap.syuugyouTimeFixed} message2row />
          </SpInputLine>

          {/* 休憩時間 */}
          <SpInputLine title="休憩時間">
            <PulldownInput
              items={restTimeList}
              selectedValue={fixedRestTime}
              onChange={handleChangeFixedRestTime}
            />
            <div className="P-C-label">分</div>
            <PcErrorArea message={errorDispMap.restTimeFixed} message2row />
          </SpInputLine>
        </div>

        {/* 就業時間 早番,日勤,遅番,夜勤 */}
        <div className="shiftWorkTime">
          {ShiftTypeList.map((shiftType)=>{
            const { 
              value,
              title,
              syuugyouTimeErrors,
              restTimeErrors,
              startHourState,
              startHourOnChange,
              startMinState,
              startMinOnChange,
              endHourState,
              endHourOnChange,
              endMinState,
              endMinOnChange,
              RestTimeState,
              RestTimeOnChange,
            } = shiftType;
            
            if(workStyleKbn.includes(value.value)){
              return(
                <>
                  {/* 就業時間 */}
                  <SpInputLine title={title}>
                    {/* 開始（時：分） */}
                    <PulldownInput
                      items={startHourList}
                      selectedValue={startHourState}
                      onChange={startHourOnChange}
                    />
                    <div className="P-C-colon">:</div>
                    <PulldownInput
                      items={startMinList}
                      selectedValue={startMinState}
                      onChange={startMinOnChange}
                    />

                    <div className="P-C-wave">~</div>
      
                    {/* 終了（時：分） */}
                    <PulldownInput
                      items={endHourList}
                      selectedValue={endHourState}
                      onChange={endHourOnChange}
                    />
                    <div className="P-C-colon">:</div>
                    <PulldownInput
                      items={endMinList}
                      selectedValue={endMinState}
                      onChange={endMinOnChange}
                    />
                    <PcErrorArea message={syuugyouTimeErrors} message2row />
                  </SpInputLine>
          
                  {/* 休憩時間 */}
                  <SpInputLine title="休憩時間">
                    <PulldownInput
                      items={restTimeList}
                      selectedValue={RestTimeState}
                      onChange={RestTimeOnChange}
                    />
                    <div className="P-C-label">分</div>
                    <PcErrorArea message={restTimeErrors} message2row />
                  </SpInputLine>
                </>
              );
            }
            return(
              <div />
            );
          })}
        </div>
      </div>

      {/* 車通勤 */}
      <div className="sp-canCommuteByCar">
        <SpInputLine title="車通勤">
          <PulldownInput
            items={canCommuteByCarList}
            onChange={handleChangeCanCommuteByCar}
            selectedValue={canCommuteByCar}
          />
          <PcErrorArea message={errorDispMap.canCommuteByCar} />
        </SpInputLine>
      </div>

      {/* 時給 */}
      <SpInputLine title="希望単価/時">
        <span className="salary-wapper">
          <span className="salary">
            <span className="textMiddle">
              <TextBox
                name="hourSalary"
                val={hourSalary}
                onChange={handleChangeHourSalary}
                maxLength="4"
              />
              <span className="yenMargin">円</span>
              <PcErrorArea message={errorDispMap.hourSalary} position="relative" message2row />
              <PcErrorArea message={warn.hourSalary} position="relative" message2row />
            </span>
          </span>
          <div className="MarketPrice">
            <SpMarketPrice 
              type="two"
              suggestHourSalaryDisp={suggestHourSalaryDisp}
            />
          </div>
        </span>
      </SpInputLine>

      {/* その他条件 */}
      <SpInputLine
        title="その他条件"
        optional="true"
      >
        <TextAreaBox
          name="freeComment"
          value={freeComment}
          onChange={handleChangeFreeComment}
          maxLength="200"
          placeholder="残業などがある場合は必ず詳細をご記入ください"
          inValid={!!errorDispMap.freeComment}
        />
        <PcErrorArea position='relative' message={errorDispMap.freeComment} />
      </SpInputLine>
      
    </SpBasicTemplate>
  </div>
);


export default PresentSP;
